import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const TELEPHONY_BUSINESS_JOB_POSITIONS_QUERY_KEY = 'telephonyBusinessJobPositionsQueryKey';

export function useTelephonyConfigBusinessJobPositions() {
	const userSession = useUserSession();
	return useQuery({
		queryFn: async () => {
			const response = await userSession.webServiceHelper.callAsync<{ value: string; description: string }[]>(
				'telephony/configuration/clientProfile/jobPositions',
				'GET'
			);
			return response;
		},
		queryKey: [TELEPHONY_BUSINESS_JOB_POSITIONS_QUERY_KEY],
	});
}
